import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { PaginationLink, PaginationListItem } from '../styles';

var PaginationItem = function PaginationItem(_ref) {
  var onChangePage = _ref.onChangePage,
      pageUrl = _ref.pageUrl,
      isActive = _ref.isActive,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["onChangePage", "pageUrl", "isActive", "children"]);

  return /*#__PURE__*/React.createElement(PaginationListItem, {
    isActive: isActive
  }, /*#__PURE__*/React.createElement(PaginationLink, _extends({
    hasButtonBehavior: true,
    href: pageUrl,
    "aria-label": "page ".concat(children),
    "data-test": "pagination-".concat(children),
    "aria-current": isActive || undefined,
    onClick: function onClick(e) {
      // need to subtract 1 as the pagination is 1-indexed
      onChangePage(parseInt(children, 10) - 1, e);
    }
  }, props), children));
};

PaginationItem.displayName = 'PaginationItem';
export default PaginationItem;